export const QueryKeys = {
  AllVendorsList: 'AllVendorsList'
}